import {NgModule} from '@angular/core';
import {ContactService} from './contact.service';
import {ContactDatatableComponent} from './contact-datatable.component';
import {ContactFormComponent} from './contact-form.component';
import {SharedModule} from '../shared/shared.module';
import {CrudModule} from '@ngx-ivengi/crud';
import {EntityContactFormComponent} from './entity-contact-form.component';

@NgModule({
  declarations: [
    ContactDatatableComponent,
    ContactFormComponent,
    EntityContactFormComponent
  ],
  exports: [
    ContactDatatableComponent,
    ContactFormComponent,
    EntityContactFormComponent
  ],
  imports: [
    SharedModule,
    CrudModule
  ],
  providers: [
    ContactService
  ]
})
export class ContactModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/contact/contact.module.ts